import api from 'services/api'

const importApi = {
    get() {
        return api.get('/api/organisaties', {
            headers: { 'Content-Type': 'application/json' }
        })
    },

    downloadResult(subject, resultFileId) {
        return api
            .get(`/api/${subject}/results/${resultFileId}`, { responseType: 'blob' })
    },

    processAfdelingen(organisatieId, file) {
        return api
            .post('/api/organisatieonderdelen')
            .field('organisatieid', organisatieId)
            .attach('File', file)
            .responseType('json')
    },

    importAfhandelaren(organisatieId, file) {
        return api
            .post('/api/afhandelaren')
            .field('organisatieid', organisatieId)
            .attach('File', file)
    },

    importMedewerkers(organisatieId, file) {
        return api
            .post('/api/medewerkers')
            .field('organisatieid', organisatieId)
            .attach('File', file)
    }
}

export default importApi
